module.exports = __webpack_public_path__ + "static/media/tracker-light.d3324ff4.svg";